// extracted by mini-css-extract-plugin
export default {"container":"TransactionPage_container__nzpJ1","header":"TransactionPage_header__eMtEv","containerLogo":"TransactionPage_containerLogo__ahWK9"};